import React, {useEffect, useRef, useState} from "react";
import {Badge, Card, CardBody, CardFooter, Image} from "@nextui-org/react";
import {useVending} from "./VendingProvider";
import {getStockbyProduct} from "../API";

export const Cell = ({index, item, idmachine, message}) => {

    const imgUrl = "https://expendedora.online/img/products/";
    const {cart, OpenDialog} = useVending();
    const [inCart, setInCart] = useState(false);
    const refCard = useRef(null);
    const [stock, setStock] = useState(true);

    useEffect(() => {
        setInCart(cart.some(s => s.idproduct === item.idproduct));
    }, [cart, item])


    async function ConfirmBuy() {
        const product = await getStockbyProduct(idmachine, item.idproduct);

        if (product) {
            OpenDialog(product);
            return;
        }

        message("Producto sin stock", "error");
        setStock(false);
    }

    return (
        <Badge color="success" content={"En el carrito"} isInvisible={!inCart} size="lg" shape="circle"
               showOutline={false} variant="shadow" placement="top-left">
            <Card ref={refCard} shadow="sm" key={index} onPress={() => ConfirmBuy()}
                  isPressable={(item.amount.length > 0 && !inCart)}>
                <CardBody className="overflow-visible p-0 aspect-square flex items-center justify-center">
                    <Image
                        shadow="sm"
                        radius="lg"
                        className="object-contain w-full h-auto aspect-square"
                        alt={item.name}
                        src={imgUrl + item.image}
                    />
                </CardBody>
                <CardFooter className="text-small justify-between">
                    <b>{item.name}</b>
                    <p className={stock ? "text-default-500" : "text-danger"}>
                        {stock ? `₲${item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}` : "Sin stock"}
                    </p>
                </CardFooter>
            </Card>
        </Badge>
    );
};

export default Cell;